import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReduxBlockUi from 'react-block-ui/redux';
import {
	fetchEnrolment, cancelAndRefundEnrolment, cancelEnrolment, deleteAutoEnrolment,
	CANCEL_AND_REFUND_ENROLMENT_REQUEST, CANCEL_AND_REFUND_ENROLMENT_SUCCESS, CANCEL_AND_REFUND_ENROLMENT_FAILURE,
	CANCEL_ENROLMENT_REQUEST, CANCEL_ENROLMENT_SUCCESS, CANCEL_ENROLMENT_FAILURE,
	DELETE_AUTO_ENROLMENT_REQUEST, DELETE_AUTO_ENROLMENT_SUCCESS, DELETE_AUTO_ENROLMENT_FAILURE
} from './actions';
import {
	cancelLesson, cancelAndRefundLesson, restoreCancelledLesson,
	CANCEL_AND_REFUND_LESSON_REQUEST, CANCEL_AND_REFUND_LESSON_SUCCESS, CANCEL_AND_REFUND_LESSON_FAILURE,
	CANCEL_LESSON_REQUEST, CANCEL_LESSON_SUCCESS, CANCEL_LESSON_FAILURE
} from '../paymentHistory/actions';
import EnrolmentSettingsForm from './SettingsForm';
import RefundDialog from './RefundDialog';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleCancelLesson = this.handleCancelLesson.bind(this);
		this.handleRestoreCancelledLesson = this.handleRestoreCancelledLesson.bind(this);
		this.handleCancelAndRefundLesson = this.handleCancelAndRefundLesson.bind(this);
		this.reloadEnrolment = this.reloadEnrolment.bind(this);
		this.hideDialog = this.hideDialog.bind(this);
		this.showDialog = this.showDialog.bind(this);
		this.handleCancellationReasonChange = this.handleCancellationReasonChange.bind(this);
		this.hideRefundEnrolmentDialog = this.hideRefundEnrolmentDialog.bind(this);
		this.showRefundEnrolmentDialog = this.showRefundEnrolmentDialog.bind(this);
		this.handleCancelAndRefundEnrolment = this.handleCancelAndRefundEnrolment.bind(this);
		this.handleCancelAllLessons = this.handleCancelAllLessons.bind(this);
		this.handleDeleteAutoEnrolment = this.handleDeleteAutoEnrolment.bind(this);

		this.state = {
			showDialog: false,
			showRefundEnrolmentDialog: false,
			cancellationReasonType: null,
			lessonId: null
		};
	}

	componentDidMount() {
		this.reloadEnrolment();
	}
	
	handleCancellationReasonChange(event, cancellationReasonType) {
		this.setState({ cancellationReasonType });
	}

	hideDialog() {
		this.setState({ showDialog: false, lessonId: null, lessonDate: null, cancellationReasonType: null });
	}

	showDialog(lessonId, lessonDate) {
		this.setState({ showDialog: true, lessonId, lessonDate });
	}

	hideRefundEnrolmentDialog() {
		this.setState({ showRefundEnrolmentDialog: false, cancellationReasonType: null });
	}

	showRefundEnrolmentDialog() {
		this.setState({ showRefundEnrolmentDialog: true });
	}

	reloadEnrolment() {
		const { match, fetchEnrolment } = this.props;
		const enrolmentId = match.params.id;

		if (enrolmentId) {
			fetchEnrolment(enrolmentId);
		}
	}

	handleCancelAndRefundLesson(options) {
		const { cancelAndRefundLesson } = this.props;
		const onSuccessEvent = () => {
			this.hideDialog();
			this.reloadEnrolment();
		};
		cancelAndRefundLesson(this.state.lessonId, options, onSuccessEvent);
	}

	handleCancelAndRefundEnrolment(options) {
		const { cancelAndRefundEnrolment, enrolmentId } = this.props;
		const onSuccessEvent = () => {
			this.hideRefundEnrolmentDialog();
			this.reloadEnrolment();
		};
		cancelAndRefundEnrolment(enrolmentId, options, onSuccessEvent);
	}

	handleCancelLesson(lessonId) {
		const { cancelLesson } = this.props;
		const onSuccessEvent = () => this.reloadEnrolment();
		cancelLesson(lessonId, onSuccessEvent);
	}

	handleCancelAllLessons() {
		const { cancelEnrolment, enrolmentId } = this.props;
		const onSuccessEvent = () => this.reloadEnrolment();
		cancelEnrolment(enrolmentId, onSuccessEvent);
	}

	handleDeleteAutoEnrolment() {
		const { deleteAutoEnrolment, enrolmentId } = this.props;
		const onSuccessEvent = () => this.reloadEnrolment();
		deleteAutoEnrolment(enrolmentId, onSuccessEvent);
	}

	handleRestoreCancelledLesson(lessonId) {
		const { restoreCancelledLesson } = this.props;
		const onSuccessEvent = () => this.reloadEnrolment();
		restoreCancelledLesson(lessonId, onSuccessEvent);
	}

	render() {
		const { enrolment, canCancelLesson, canViewNotes, isReadonly, parentId , t, cancellationReasonTypes, enableAutoEnrolment, hasDeleteAutoEnrolmentPermission} = this.props;

		if (enrolment) {
			return (
				<div>	
					<RefundDialog bsSize='large' show={this.state.showDialog}
						title={t('PaymentHistory_CancelAndRefundLessonConfirmationTitle')}
						buttonLabel={t('ChildLesson_CancellationAndRefund')}
						onCancel={this.hideDialog}
						onConfirm={this.handleCancelAndRefundLesson}
						cancellationReasonTypes={cancellationReasonTypes}
						initialValues={{ lessonDate: this.state.lessonDate }}
						onReasonChange={this.handleCancellationReasonChange}
						cancellationReasonType={this.state.cancellationReasonType}
						block={CANCEL_AND_REFUND_LESSON_REQUEST}
						unblock={CANCEL_AND_REFUND_LESSON_SUCCESS, CANCEL_AND_REFUND_LESSON_FAILURE}
					/>
					<RefundDialog bsSize='large' show={this.state.showRefundEnrolmentDialog}
						title={t('Enrolment_CancelAndRefundEnrolmentConfirmationTitle')}
						buttonLabel={t('Enrolment_CancelAndRefundAllLessons')}
						onCancel={this.hideRefundEnrolmentDialog}
						onConfirm={this.handleCancelAndRefundEnrolment}
						cancellationReasonTypes={cancellationReasonTypes}
						onReasonChange={this.handleCancellationReasonChange}
						cancellationReasonType={this.state.cancellationReasonType}
						block={CANCEL_AND_REFUND_ENROLMENT_REQUEST}
						unblock={[CANCEL_AND_REFUND_ENROLMENT_SUCCESS, CANCEL_AND_REFUND_ENROLMENT_FAILURE]}
					/>
					<ReduxBlockUi block={[CANCEL_LESSON_REQUEST, CANCEL_ENROLMENT_REQUEST, CANCEL_AND_REFUND_LESSON_REQUEST, CANCEL_AND_REFUND_ENROLMENT_REQUEST, DELETE_AUTO_ENROLMENT_REQUEST]}
						unblock={[CANCEL_LESSON_SUCCESS, CANCEL_LESSON_FAILURE, CANCEL_ENROLMENT_SUCCESS, CANCEL_ENROLMENT_FAILURE,
							CANCEL_AND_REFUND_LESSON_SUCCESS, CANCEL_AND_REFUND_LESSON_FAILURE, CANCEL_AND_REFUND_ENROLMENT_SUCCESS, CANCEL_AND_REFUND_ENROLMENT_FAILURE,
							DELETE_AUTO_ENROLMENT_SUCCESS, DELETE_AUTO_ENROLMENT_FAILURE]}>
						<EnrolmentSettingsForm
							isReadonly={isReadonly}
							initialValues={enrolment}
							lessons={enrolment.allLessons}
							canCancelLesson={canCancelLesson}
							cancelAndRefundLesson={this.showDialog}
							cancelAndRefundEnrolment={this.showRefundEnrolmentDialog}
							cancelLesson={this.handleCancelLesson}
							restoreCancelledLesson={this.handleRestoreCancelledLesson}
							cancelAllLessons={this.handleCancelAllLessons}
							deleteAutoEnrolment={this.handleDeleteAutoEnrolment}
							enableAutoEnrolment={enableAutoEnrolment}
							hasDeleteAutoEnrolmentPermission={hasDeleteAutoEnrolmentPermission}
							parentId={parentId}
							canViewNotes={canViewNotes}
							/>
					</ReduxBlockUi>

				</div>
			);
		}
		return null;
	}
}

const mapStateToProps = (state, ownProps) => {
	const enrolmentId = ownProps.match.params.id;
	const parentId = ownProps.match.params.parentId;
	const fromPath = ownProps.match.params.fromPath;

	const {
		entities: { enrolments },
		lookups: { cancellationReasonTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const enrolment = enrolments[enrolmentId];
	let canCancelLesson, canViewNotes, hasDeleteAutoEnrolmentPermission;
	if (enrolment) {
		canCancelLesson = authUtils.hasPermission(currentUser, 'CancelChildLesson');
		canViewNotes = authUtils.hasPermission(currentUser, 'Notes');
		hasDeleteAutoEnrolmentPermission = authUtils.hasPermission(currentUser, 'DeleteAutoEnrolment');
	}

	return {
		enrolment: enrolment,
		enrolmentId: enrolmentId,
		canCancelLesson,
		canViewNotes,
		hasDeleteAutoEnrolmentPermission,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'PaymentHistrory'),
		parentId,
		fromPath,
		cancellationReasonTypes,
		enableAutoEnrolment: franchisor.enableAutoEnrolment
	};
};

export default connect(mapStateToProps, {
	fetchEnrolment,
	cancelLesson,
	restoreCancelledLesson,
	cancelAndRefundLesson,
	cancelAndRefundEnrolment,
	cancelEnrolment,
	deleteAutoEnrolment
})(withTranslation()(Details));